import { PotentialSpouseClaimBasedOnCategory } from '@/modules/liability/enums/PotentialSpouseClaimBasedOnCategory';
import Lang from '/@/modules/core/app/services/Lang';

export class PotentialSpouseClaimLiabilityMeta {
  basedOn: PotentialSpouseClaimBasedOnCategory[];

  constructor(model: Partial<PotentialSpouseClaimLiabilityMeta> = {}) {
    this.basedOn = model.basedOn ?? [];
  }

  get title(): string {
    return Lang.t('liability.potential-spouse-claim-to');
  }

  get formattedBasedOn(): string {
    if (!this.basedOn.length) {
      return '';
    }

    const firstBasedOnValue: string = this.basedOn[0].value;

    if (this.basedOn.length === 1) {
      return firstBasedOnValue;
    }

    return firstBasedOnValue + ' ' + Lang.t('core.and') + ' ' + this.basedOn[1].value;
  }
}
